import * as tslib_1 from "tslib";
import React from 'react';
import omit from 'lodash.omit';
import StandardThumb from '../../DeviationViews/Thumb/Standard';
import { getLargestFullview } from '../../DeviationViews/_helpers';
import MeasuredTorpedo from '../MeasuredTorpedo';
import { preloadFeature } from '../../Duperbrowse/redux/constants';
import { useFlag } from '../../redux/flags/hooks/useFlag';
import { makeDeviationId } from '../../redux/normalizr/schemas/deviation';
export var itemRenderer = function (renderProps, item, itemStyle) {
    return (React.createElement(StandardThumb, { key: "item-" + item.idx, deviation: item.dto.deviation, width: item.width, height: item.height, style: itemStyle }));
};
var DeviationTorpedo = function (props) {
    var hasPreloadFeature = useFlag(preloadFeature);
    var ignoreProps = ['items', 'renderItem'];
    var torpedoProps = omit(props, ignoreProps);
    var items = props.items.map(function (item) {
        var largest = getLargestFullview(item);
        return {
            id: "deviation-" + item.deviationId,
            width: largest.width,
            height: largest.height,
            deviation: item,
            duperbrowseItemId: hasPreloadFeature
                ? makeDeviationId(item)
                : item.deviationId,
        };
    });
    return (React.createElement(MeasuredTorpedo, tslib_1.__assign({ items: items, renderItem: itemRenderer }, torpedoProps)));
};
DeviationTorpedo.displayName = 'DeviationTorpedo';
export default DeviationTorpedo;
//# sourceMappingURL=DeviationTorpedo.js.map